import moment from "moment";
import {USE_IMAGE_PLACEHOLDERS} from "./constants/paths";
import _ from "lodash";
import LocalShippingTwoToneIcon from '@mui/icons-material/LocalShippingTwoTone';
import DirectionsBoatTwoToneIcon from '@mui/icons-material/DirectionsBoatTwoTone';

export const getAssetPath = (url, size) => {
    if(USE_IMAGE_PLACEHOLDERS) {
        return `https://via.placeholder.com/${size}.png`;
    }

    return url;
};

export const defaultSwalPreferences = (swalObj) => {
    return {
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
            toast.addEventListener('mouseenter', swalObj.stopTimer);
            toast.addEventListener('mouseleave', swalObj.resumeTimer);
        }
    }
}

export const geoCoords = strCoords => {
    var out = _.map(_.compact(_.split(strCoords, ";")), (p) => { return {lat: parseFloat(_.split(p, ',')[0]), lng: parseFloat(_.split(p, ',')[1]) } })
    return out
}

// Punto dentro de polígono por ray casting, el mismo criterio que usa Geokit en
// el backend al armar las rutas por zona de despacho. Se resuelve acá y no con
// google.maps.geometry para no depender de que el mapa esté cargado.
export const pointInPolygon = (point, polygon) => {
    const lat = Number(point?.lat);
    const lng = Number(point?.lng);
    if (!_.isFinite(lat) || !_.isFinite(lng)) return false;
    if (!polygon || polygon.length < 3) return false;

    let inside = false;
    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
        const yi = polygon[i].lat, xi = polygon[i].lng;
        const yj = polygon[j].lat, xj = polygon[j].lng;
        if (!_.isFinite(yi) || !_.isFinite(xi) || !_.isFinite(yj) || !_.isFinite(xj)) continue;
        // El segmento cruza la horizontal del punto y el cruce queda a su derecha.
        const crosses = (yi > lat) !== (yj > lat)
            && lng < ((xj - xi) * (lat - yi)) / (yj - yi) + xi;
        if (crosses) inside = !inside;
    }
    return inside;
}

// Cierre convexo (convex hull) por monotone chain de Andrew. Ordena los
// puntos y arma la envolvente convexa en orden CCW, de modo que el polígono
// nunca quede cruzado/cóncavo sin importar el orden de los clicks.
export const convexHull = (points) => {
    const uniq = _.uniqBy(points, (p) => `${p.lat},${p.lng}`);
    if (uniq.length < 3) return uniq;
    const pts = uniq.slice().sort((a, b) => (a.lng - b.lng) || (a.lat - b.lat));
    // > 0 => giro a la izquierda (CCW). lng = x, lat = y.
    const cross = (o, a, b) => (a.lng - o.lng) * (b.lat - o.lat) - (a.lat - o.lat) * (b.lng - o.lng);
    const lower = [];
    for (const p of pts) {
        while (lower.length >= 2 && cross(lower[lower.length - 2], lower[lower.length - 1], p) <= 0) lower.pop();
        lower.push(p);
    }
    const upper = [];
    for (let i = pts.length - 1; i >= 0; i--) {
        const p = pts[i];
        while (upper.length >= 2 && cross(upper[upper.length - 2], upper[upper.length - 1], p) <= 0) upper.pop();
        upper.push(p);
    }
    lower.pop();
    upper.pop();
    return lower.concat(upper);
}

// Horario preferente heredado de la dirección del cliente (Clientes > horario
// preferente por dirección). El backend lo resuelve contra la dirección con la
// que se rutea la entrega y lo expone en inherited_preferred_arrival_*.
// Devuelve null si esa dirección no tiene horario configurado.
export const inheritedAddressSchedule = (delivery) => {
    const start = delivery?.inherited_preferred_arrival_start
    const end = delivery?.inherited_preferred_arrival_end
    if (!start && !end) return null
    return { start, end }
}

export const getAvatarInitials = (str) => {
    let initials = str.match(/\b\w/g) || [];
    initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
    return initials;
}

export const optimizerNames = (slug) => {
    switch(slug) {
        case 'route-optimizer-by-delivery-zones':
            return 'Zonas de despacho';
        default:
            return 'Desconocido';
    }
}

export const encodeParams = (strparams) => {
    // const params = {
    //     include: "customer",
    //     "q[code_or_customer_name_cont]": "hola"
    // };
    var out = ""
    _.map(_.split(strparams, '&'), (p) => {
        var [k, v] = _.split(p, '=')
        if(out.length > 0) {
            out = `${out}&`
        }
        out = `${out}${encodeURIComponent(k)}=${encodeURIComponent(v)}`
    })
    return out
}

export const downloadBuffer = (buffer, fileName) => {
    const blob = new Blob(
      [ buffer ],
      { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
    )
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName); // Establece el nombre del archivo aquí.
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
}

export const prettyDuration = (_start, _end) => {
    const start_ = moment(_start)
    const end_ = moment(_end)
    const diff = moment.duration(end_.diff(start_));
    var horas = diff.hours();
    var minutos = diff.minutes();
    var segundos = diff.seconds();
    var output = []
    if(horas > 0) { output.push(`${horas}h`) }
    output.push(`${minutos}m`)
    output.push(`${segundos}s`)

    return output.join(" ")
    // return moment.utc(end.diff(start).asMilliseconds()).format("HH:mm:ss.SSS")
}

export const hasPlugin = (pluginList, plugin) => {
    if(pluginList && _.find(pluginList, { slug: plugin })) {
        return true;
    }
    return false;
}

export const vehicleIcon = (vh) => {
    var tus = [vh?.transport_unit1?.kind, vh?.transport_unit2?.kind]
    if(_.includes(tus, 'barge')) {
        return <DirectionsBoatTwoToneIcon fontSize="small" color={"primary"} />
    } else if(_.includes(tus, 'truck')) {
        return <LocalShippingTwoToneIcon fontSize="small" color={"primary"} />
    } else {
        return <LocalShippingTwoToneIcon fontSize="small" color={"primary"} />
    }
}